import { cn } from "@nexus/ui";
import type { PreflightPlatformCode } from "@nexus/contracts";
import { PLATFORM_BRAND_ICONS } from "../../constants/platform-icons";

export interface PlatformIconProps {
  platform: PreflightPlatformCode;
  className?: string;
}

/**
 * A platform's brand mark in its brand colour.
 *
 * Every current caller pairs it with the platform's text label, so it is decorative
 * and hidden from assistive tech rather than announcing the name twice.
 */
export function PlatformIcon({ platform, className }: PlatformIconProps) {
  const { Glyph, colorClassName } = PLATFORM_BRAND_ICONS[platform];

  return (
    <Glyph
      aria-hidden
      focusable={false}
      title=""
      className={cn("size-3.5 shrink-0", colorClassName, className)}
    />
  );
}
